import { createAction } from '@reduxjs/toolkit'
import reducer from './reducer'

export const {
  fetchGptPromptsSuccess,
  fetchGptPromptsFailure,
  updateGptPromptSuccess,
  clearData,
} = reducer.actions

export const fetchGptPromptsRequest = createAction('gptPrompts/fetchRequest')
export const updateGptPromptRequest = createAction('gptPrompts/updateRequest')
